import React, { PureComponent } from 'react'
import styles from './GhostBanner.scss'
import config from '@public-config'

class GhostBanner extends PureComponent {
  render() {
    const ghostImageUrl = encodeURIComponent(`${config.imageAssetUrl}/icon/place-ghost@2x.png`)
    const choioceImageUrl = encodeURIComponent(`${config.imageAssetUrl}/icon/place-choice@2x.png`)
    const {
      ghost: {
        place: {
          coordinates: { lat, lng },
        },
      },
      recommendPlaces,
      onClick,
    } = this.props
    const { mapboxApiToken } = config
    const markers = [`url-${ghostImageUrl}(${lng},${lat})`].concat(
      recommendPlaces
        .filter((p) => Boolean(p))
        .map(
          ({
            place: {
              coordinates: { lat, lng },
            },
          }) => `url-${choioceImageUrl}(${lng},${lat})}`,
        ),
    )
    const markerUrls = markers.join(',')
    const mapUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${markerUrls}/${lng},${lat},15/1000x144@2x?access_token=${mapboxApiToken}`
    return (
      <div className="ghost_banner" onClick={onClick}>
        <style jsx>{styles}</style>
        <img src={mapUrl} />
      </div>
    )
  }
}

export default GhostBanner
